var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge-info",class:_vm.variant},[_vm._v(_vm._s(_vm.content))])
}
var staticRenderFns = []

export { render, staticRenderFns }